import { differenceInSeconds } from 'date-fns';

export class AuthConfiguration {
  constructor(
    public readonly needsAuthentication: boolean,
    public readonly allowAnyAnonymousAccess: boolean,
    public readonly useLocalSecurityContext: boolean,
    public readonly useRemoteSecurityContext: boolean,
    public readonly allowIntegratedSecurity: boolean,
    public readonly fixedCulture: string,
    public readonly queryDate: Date,
    public readonly webApiUrlUsedForQuery: string,
    public readonly clientPingIntervalMinutes: number,
    public readonly clientPingTimeoutMilliseconds: number,
    public readonly requestContentEncoding: string,
    public readonly version: string,
    public readonly systemName: string,
  ) {}

  public get queryAgeMinutes(): number {
    return Math.abs(differenceInSeconds(this.queryDate, new Date())) / 60.0;
  }
}

export interface ISupportsRequestHeaderValues {
  getRequestHeaderValue?(name: string): string;
}
